<template>
  <div>
    <image-text :info="textsToImageHome"></image-text>

    <div class="grid">

      <div class="border-seperator">
        <div>
          <div>
            <h2>{{ $t(`label.homePage.title2`) }}</h2>
            <article>
              <p>{{ $t('label.homePage.info2.title1') }}</p>
              <p>{{ $t('label.homePage.info2.title2') }}</p>
              <p>{{ $t('label.homePage.info2.title3') }}</p>
              <p>{{ $t('label.homePage.info2.title4') }}</p>
              <p>{{ $t('label.homePage.info2.title5') }}</p>
            </article>
          </div>
        </div>

        <div class="col-50">
          <div class="block">
            <div class="align-logo">
              <img :src="require(`@/assets/logos/tns.jpg`)" alt="{{}}" class="logo-tns" />
              <h2 class="margin-left-2">
                {{ $t('label.homePage.title1') }}
              </h2>
            </div>

            <article>
              <p>{{ $t('label.homePage.info1.title1') }}</p>
              <p>{{ $t('label.homePage.info1.title2') }}</p>
              <p>{{ $t('label.homePage.info1.title3') }}</p>
              <p>{{ $t('label.homePage.info1.title4') }}</p>
            </article>
          </div>
        </div>

        <div class="col-50">
          <div class="block">
            <div class="align-logo">
              <img :src="require(`@/assets/logos/namsando.jpg`)" alt="{{}}" class="logo-namsando" />
              <h2  class="margin-left-2">
                {{ $t('label.homePage.info3.title1') }}
              </h2>
            </div>
            <article>
              <p>{{ $t('label.homePage.info3.title2') }}</p>
              <p>{{ $t('label.homePage.info3.title3') }}</p>
            </article>
          </div>
        </div>

        <div class="clear"></div>
      </div>

      <div class="margin-bottom-2">
        <div class="col-50">
          <h2 class="no-margin">{{ $t('label.homePage.location1') }}</h2>
          <div class="block responsive-map">
            <iframe
              src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2035.8367944438678!2d-3.8089132577128124!3d40.291985701722496!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0xd418b9f27893ea9%3A0x4ce751f2bdea9525!2sGimnasio+Nam+San!5e0!3m2!1ses!2ses!4v1521744430378"
              width="600" height="450" frameborder="0" style="border:0" allowfullscreen></iframe>
          </div>
        </div>
        <div class="col-50">
          <h2 class="no-margin">{{ $t('label.homePage.location2') }}</h2>
          <div class="block responsive-map">
            <iframe
              src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3040.894415572607!2d-3.541441624058042!3d40.344688171451295!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0xd423bdda21977d1%3A0xb19dac5e32e03239!2sEscuela%20De%20Artes%20Marciales%20NAM%20KUN%20Rivas!5e0!3m2!1ses!2ses!4v1739095181490!5m2!1ses!2ses"
              width="600" height="450" frameborder="0" style="border:0" allowfullscreen></iframe>
          </div>
        </div>
        <div class="clear"></div>
      </div>
      <form-contact></form-contact>
    </div>
  </div>
</template>

<script>
import ImageText from "@/components/image-text/ImageText.vue";
import FormContact from "@/components/form-contact/FormContact.vue";
import CONSTANTS from "./constants.js";
export default {
  name: "Home",

  components: {
    ImageText,
    FormContact
  },

  computed: {
    textsToImageHome() {
      return {
        title: "imageHome.title",
        subTitle: "imageHome.subTitle",
        email: "imageHome.email",
        image: CONSTANTS.FIRST_IMAGE
      };
    }
  }
};
</script>

<style>
.margin-left-2 {
  margin-left: 15px;
}
.align-logo {
  justify-content: center;
  display: flex;
  align-items: center;
}

.logo-tns {
  width: 50px;
  height: 50px;
}

.logo-namsando {
  width: 50px;
  height: 50px;
}

.no-margin {
  margin: 0;
  margin-bottom: 20px;
}

.block {
  display: block;
  margin-right: 6%;
  margin-left: 6%;
}

.grid {
  width: 90%;
  margin: 0 auto;
}

.col-50 {
  width: 50%;
  float: left;
}

.col-25 {
  width: 25%;
  float: left;
}

.margin-bottom-2 {
  margin-bottom: 20px;
}

.clear {
  clear: both;
  display: block;
}

div.border-seperator {
  border-bottom: 1px solid #ccc;
  margin-bottom: 20px;
}

.responsive-map {
  overflow: hidden;
  margin-top: 10px;
  position: relative;
  height: 233px;
}

.responsive-map iframe {
  left: 0;
  top: 0;
  height: 100%;
  width: 100%;
  position: absolute;
}

@media all and (max-width:700px) {
  .col-50 {
    width: 100%;
    float: none;
  }

  .col-25 {
    width: 100%;
    float: none;
  }

  .no-margin {
    margin-top: 20px;
    margin-bottom: 20px;
  }

  input,
  textarea {
    float: none;
  }
}

@media (max-width:400px) {
  .block {
    min-width: 280px;
    margin-right: 0;
    margin-left: 0;
  }
}
</style>
